import { trackAnalyticsEvent } from '@autone/analytics';

import { Button } from '../../../../atoms';
import { type LanguageItemProps } from '../LanguageSelector.types';

/**
 * Individual language item component
 * Displays a single language option with icon and label
 *
 * @param props - Language item properties
 * @returns JSX element for a single language option
 */
export const LanguageItem: React.FC<LanguageItemProps> = ({
  langKey,
  label,
  icon: Icon,
  onSelectLanguage,
}) => {
  return (
    <li>
      <Button
        id="language-item"
        aria-label="language item"
        variant="ghost"
        className="w-full justify-start gap-3 p-2 h-auto"
        onClick={() => {
          trackAnalyticsEvent({
            category: 'sidebar',
            action: 'language_selector_clicked',
            properties: { language: label },
          });
          onSelectLanguage(langKey);
        }}
      >
        <Icon />
        <span className="text-sm font-normal">{label}</span>
      </Button>
    </li>
  );
};
